import React from 'react';
import { List, Image, Popup } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getTeamCssClass, getFriendlyTeamName } from '../../helpers/clubHelper';
import { encodeClubUrl } from '../../helpers/clubHelper';
import './FixtureItem.css';

const FixtureItem = (fixture, clubId, history) => {
  const calcScore = score => {
    const goalsAsPoints = score.goals * 3;
    return parseInt(goalsAsPoints + score.points, 10);
  };
  const isHomeVictory =
    calcScore(fixture.result.home) > calcScore(fixture.result.away);

  const isDraw =
    calcScore(fixture.result.home) === calcScore(fixture.result.away);

  const homeUrl =
    clubId === fixture.home.id ? '#' : encodeClubUrl(fixture.home);

  const awayUrl =
    clubId === fixture.away.id ? '#' : encodeClubUrl(fixture.away);

  return (
    <List.Item key={fixture._id}>
      <List.Content>
        <List.Description className="fixture-item">
          <span className="fixture-item__cell fixture-item__name">
            <Popup
              trigger={<span className={getTeamCssClass(fixture)} />}
              content={getFriendlyTeamName(fixture)}
            />
            {fixture.name}
          </span>
          <a
            href={homeUrl}
            className={`fixture-item__cell fixture-item__home ${
              fixture.isResult && isHomeVictory && !isDraw
                ? 'fixture-item_winner'
                : ''
            }`}
          >
            {fixture.home.name}
            <Image avatar src={fixture.home.img} />
          </a>
          {fixture.isResult ? (
            <span className="fixture-item__cell fixture-item__center">
              <div className="fixture-item__time">
                {moment(fixture.datetime).format('DD MMM YYYY')}
              </div>
              <div className="fixture-item__date">
                <span
                  className={`fixture-item__home-result ${
                    fixture.isResult && isHomeVictory && !isDraw
                      ? 'fixture-item_winner'
                      : ''
                  }`}
                >{`${fixture.result.home.goals}-${
                  fixture.result.home.points
                }`}</span>
                <span
                  className={`fixture-item__away-result ${
                    fixture.isResult && !isHomeVictory && !isDraw
                      ? 'fixture-item_winner'
                      : ''
                  }`}
                >{`${fixture.result.away.goals}-${
                  fixture.result.away.points
                }`}</span>
              </div>
            </span>
          ) : (
            <span className="fixture-item__cell fixture-item__center">
              <div className="fixture-item__date">
                {moment(fixture.datetime).format('DD MMM YYYY')}
              </div>
              <div className="fixture-item__time">
                {moment(fixture.datetime).format('LT')}
              </div>
            </span>
          )}
          <a
            href={awayUrl}
            className={`fixture-item__cell fixture-item__away ${
              fixture.isResult && !isHomeVictory && !isDraw
                ? 'fixture-item_winner'
                : ''
            }`}
          >
            <Image avatar src={fixture.away.img} />
            {fixture.away.name}
          </a>
        </List.Description>
      </List.Content>
    </List.Item>
  );
};

FixtureItem.defaultProps = {
  history: {}
};

FixtureItem.propTypes = {
  fixtures: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    datetime: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    countryBoard: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isResult: PropTypes.bool.isRequired,
    code: PropTypes.string.isRequired,
    gender: PropTypes.string.isRequired,
    home: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      img: PropTypes.string.isRequired
    }),
    away: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      img: PropTypes.string.isRequired
    }),
    competition: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }),
    result: PropTypes.shape({
      home: PropTypes.shape({
        goals: PropTypes.number.isRequired,
        points: PropTypes.number.isRequired
      }),
      away: PropTypes.shape({
        goals: PropTypes.number.isRequired,
        points: PropTypes.number.isRequired
      })
    })
  }).isRequired
};

export default FixtureItem;



// WEBPACK FOOTER //
// ./src/components/Fixtures/FixtureItem.js